// Client-side auth helpers.
//
// The password is verified SERVER-SIDE (see server/index.js) — it never ships in
// the JS bundle. The browser only stores the signed, expiring session token the
// backend issues on a successful login.

const STORAGE_KEY = 'influs_auth';

// Returns the stored session token, or null if missing/expired.
export function getToken() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { token, expiry } = JSON.parse(raw);
    if (!token || Date.now() > expiry) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return token;
  } catch {
    return null;
  }
}

export function checkAuth() {
  return getToken() !== null;
}

export function logout() {
  localStorage.removeItem(STORAGE_KEY);
}

// True if the backend requires a login (LOGIN_PASSWORD configured). Fails closed
// (requires login) if the backend is unreachable.
export async function isAuthRequired() {
  try {
    const res = await fetch('/api/auth/config');
    if (!res.ok) return true;
    const { authRequired } = await res.json();
    return Boolean(authRequired);
  } catch {
    return true;
  }
}

// Attempts a login. Returns true on success (token stored), false otherwise.
export async function login(password, remember) {
  const res = await fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password, remember }),
  });
  if (!res.ok) return false;
  const { token, expiry } = await res.json();
  if (!token) return false;
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, expiry }));
  return true;
}
